import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'antd';
import { apiHolder as api, apis } from 'api';
import classnames from 'classnames';
import ErrorIcon from '@web-common/components/UI/Icons/svgs/ErrorSvg';
import style from './index.module.scss';
import { getIn18Text } from 'api';
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const SendErrorContect = ({ visible, setVisible, receiver, confirm, currentMailMailListMap }) => {
    const [person, setPerson] = useState([]);
    const [mailList, setMailList] = useState([]);
    useEffect(() => {
        if (receiver && receiver.length) {
            const person = [];
            const mailList = [];
            receiver.forEach(item => {
                const isMailList = item.contactItem.type === 'external' ? currentMailMailListMap.mail[item === null || item === void 0 ? void 0 : item.contactItem.contactItemVal] : currentMailMailListMap.id[item === null || item === void 0 ? void 0 : item.contact.contact.id];
                if (isMailList) {
                    mailList.push(item);
                    return;
                }
                person.push(item);
            });
            setPerson(person);
            setMailList(mailList);
        }
    }, [receiver]);
    const trackClickBtn = (buttonName) => {
        trackApi.track('pcMail_click_button_outDomainRemind_writeMailPage', { buttonName });
    };
    const content = receiver.length > 0 && (React.createElement("div", { className: classnames(style.errorContect) }, receiver.map(item => (React.createElement("div", { className: classnames(style.outDomain) },
        item.contact.contact.contactName,
        "\uFF08",
        item.contact.contact.accountName,
        "\uFF09")))));
    return (React.createElement(Modal, { wrapClassName: "modal-dialog", onCancel: () => {
            setVisible(false);
        }, visible: visible, footer: null },
        React.createElement("div", { className: "modal-content", style: { marginTop: '10px' } },
            React.createElement("div", { className: "modal-icon" },
                React.createElement(ErrorIcon, { className: "error-icon" })),
            React.createElement("div", { className: "modal-text" },
                React.createElement("div", { className: "title" }, getIn18Text('RENWUYOUJIANZAN11')),
                React.createElement("div", { className: style.subTitle },
                    getIn18Text('GONG'),
                    !!person.length && `${person.length}个企业外邮箱地址`,
                    !!person.length && !!mailList.length && '，',
                    !!mailList.length && `${mailList.length}个邮件列表`,
                    "\uFF1A"),
                content,
                React.createElement("div", { className: "btns" },
                    React.createElement("div", null),
                    React.createElement("div", null,
                        React.createElement(Button, { className: "cancel", onClick: () => {
                                trackClickBtn(getIn18Text('QUXIAO'));
                                setVisible(false);
                            } }, getIn18Text('QUXIAO')),
                        React.createElement(Button, { className: "cancel", onClick: () => {
                                confirm();
                                trackClickBtn(getIn18Text('SHANCHUBINGJIXU'));
                                setVisible(false);
                            } }, getIn18Text('SHANCHUCUOWUYOU'))))))));
};
export default SendErrorContect;
